const BallCountType = {
	BestBall: 0,
	BestTwoBalls: 1,
	AllBalls: 2,
	BestAndWorstBall: 3
};

const BallCountValue = {
  0: "bestBall",
  1: "bestTwoBalls",
  2: "allBalls",
  3: "bestAndWorstBall"
};

export { BallCountType, BallCountValue };
